import React from 'react';
import styles from './intelligenceInsightsModules.module.css';

function extractGeneratedLabel(version) {
    if (version?.generatedLabel) return version.generatedLabel;
    const meta = String(version?.meta || '');
    const generatedPart = meta
        .split('·')
        .map(part => part.trim())
        .find(part => /^Generated/i.test(part));
    if (generatedPart) {
        return generatedPart.replace(/^Generated\s+/i, '');
    }
    const match = meta.match(/Generated\s+(.+)$/i);
    return match?.[1]?.trim() || null;
}

/**
 * Full-width banner shown while viewing a superseded analysis version (Figma historical state).
 */
const InsightsHistoricalVersionBanner = ({ version, onReturnToCurrent }) => {
    if (!version) return null;

    const generatedLabel = extractGeneratedLabel(version);
    const title = version.label
        ? `Viewing ${version.label} · Historical version`
        : 'Viewing historical version';
    const message = generatedLabel
        ? `This is a read-only snapshot of Intelligence Insights generated on ${generatedLabel}. All actions are disabled.`
        : 'This is a read-only snapshot of Intelligence Insights. All actions are disabled.';

    return (
        <div className={styles.historicalVersionBanner} role="status">
            <div className={styles.historicalVersionBannerText}>
                <p className={styles.historicalVersionTitle}>{title}</p>
                <p className={styles.historicalVersionMessage}>{message}</p>
            </div>
            {onReturnToCurrent ? (
                <button
                    type="button"
                    className={styles.historicalVersionAction}
                    onClick={onReturnToCurrent}>
                    Return to current version
                </button>
            ) : null}
        </div>
    );
};

export default InsightsHistoricalVersionBanner;
